import onQuery from 'typesaurus/onQuery';
import { useEffect, useState } from '../adaptor';
export default function useOnQuery(collection, queries) {
    const [result, setResult] = useState(undefined);
    const [error, setError] = useState(undefined);
    const loading = result === undefined && !error;
    const deps = [JSON.stringify(collection), JSON.stringify(queries)];
    useEffect(() => {
        if (result)
            setResult(undefined);
        if (queries)
            return onQuery(collection, queries, setResult, setError);
    }, deps);
    return [result, { loading, error }];
}
//# sourceMappingURL=index.js.map